/**
 * Slugify utility for generating URL-friendly slugs from text
 *
 * Usage: Add data-slug-source attribute to any input field
 * Example: <input data-slug-source="input[name='author[name]']" />
 */

import slugifyLib from 'slugify';

export function makeSlug(text: string, maxLength = 60): string {
  if (!text?.length) return '';

  const slug = slugifyLib(text, {
    lower: true,
    strict: true,
    trim: true,
  });

  return slug.substring(0, maxLength);
}

export function initSlugify(): void {
  document.querySelectorAll('input[data-slug-source]').forEach((targetInput) => {
    const input = targetInput as HTMLInputElement;
    const sourceSelector = input.getAttribute('data-slug-source');

    if (!sourceSelector) return;

    input.addEventListener('focus', () => {
      const sourceElement = document.querySelector(sourceSelector) as HTMLInputElement;

      if (input.value === '') {
        const sourceValue = sourceElement?.value || '';
        if (sourceValue) {
          // Optional wrapping, e.g. sitemap uris are stored as "/slug.htm".
          input.value = (input.dataset.slugPrefix ?? '') + makeSlug(sourceValue) + (input.dataset.slugSuffix ?? '');
          input.select();
        }
      }
    });
  });
}
